import { render } from "./InstallPic.vue?vue&type=template&id=4663b270&scoped=true"
import script from "./InstallPic.vue?vue&type=script&lang=js"
export * from "./InstallPic.vue?vue&type=script&lang=js"

import "./InstallPic.vue?vue&type=style&index=0&id=4663b270&scoped=true&lang=css"

import exportComponent from "C:\\Users\\c.turnbull.VT\\Documents\\GitHub\\vars-portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4663b270"]])

export default __exports__